import { Component, Input } from '@angular/core';
import { QaiIconComponent, QaiIconKind } from '@qai/ui';

/** Background treatment. `muted` is the grey variant. */
export type MessageBlockTone = 'default' | 'muted';

/** Layout alignment. `left` switches to a left-anchored, inline-alert layout. */
export type MessageBlockContentPlacement = 'center' | 'left';

/**
 * A bordered, centred box that says one thing to the user, with an optional
 * leading icon.
 *
 * Content is projected rather than taken as a string input so callers can
 * embed markup such as a link. Omit `icon` when the projected content brings
 * its own leading visual, as a `qai-loading` spinner does.
 *
 * Set `contentPlacement="left"` for an inline-alert layout with left-anchored
 * text. Combine with `[featuredIcon]="true"` to render the icon inside the
 * brand-coloured concentric-ring decoration used for AI-generated content notices.
 */
@Component({
  selector: 'app-message-block',
  standalone: true,
  templateUrl: './message-block.component.html',
  styleUrls: ['./message-block.component.scss'],
  imports: [QaiIconComponent],
})
export class MessageBlockComponent {
  @Input() icon?: QaiIconKind;
  @Input() tone: MessageBlockTone = 'default';
  @Input() contentPlacement: MessageBlockContentPlacement = 'center';
  /** Wraps the icon in the concentric-ring decoration. Only meaningful when `icon` is set. */
  @Input() featuredIcon: boolean = false;
  @Input() iconColor?: string;
}
